import React, { useCallback } from 'react';

import { useDispatch } from 'react-redux';
import * as chatActions from 'modules/chat';


const Header = () => {
  const dispatch = useDispatch();


  const handleClick = useCallback(() => {
    window.open('http://www.moeme.co.kr/')
  }, []);

  
  const handleGoHome = useCallback((e) => {
    e.preventDefault();
    dispatch(chatActions.goDefaultChannel())
  }, [dispatch]);


  return (
    <header>
      <div className="inwrap">
        <h1><a href="/" onClick={handleGoHome}><img src="/static/images/layout/logo.png" alt="" /></a></h1>
          <div className="menu">
            <button type="button" className="btn c_danube" onClick={handleClick}>이슈 더 보기</button>
          </div>
        </div>
    </header>
  )
}

export default Header;